import { HpGetNavigationTabControlFunction } from '../../../engineClient/components/formControls/common/navigationTabControlTypes';
import { NavigationTabMenuControl } from '../../../engineClient/components/formControls/common/navigationTabMenuControl';
import { resolveSectionText } from '../../../tools/sectionTextResolver';
import { sectionIds } from '../../../types/questionConstants';
import { HpClaimsMetaData } from '../../../types/stateTypes';

export const getClaimsJourneyNavigationTabControl: HpGetNavigationTabControlFunction<HpClaimsMetaData> = ({
  answers,
  metaData,
  completeJourney
}) => {
  let submitClaimAction: React.MouseEventHandler<HTMLElement> | undefined;
  const isJourneyComplete: boolean = !!metaData && metaData.isJourneyComplete === true;
  if (isJourneyComplete) {
    submitClaimAction = completeJourney;
  }

  const { coverAlert, readOnlySummary } = sectionIds;
  const NavigationTabControl = (props) => {
    const { items: subItems, highestTouchedKey } = props;
    // Tab names come from the section `title`, which the engine leaves unresolved.
    const items = subItems
      .filter((item) => item.key !== coverAlert)
      .map((item) => ({ ...item, name: resolveSectionText(item.name, answers) as string }));
    const updatedHighestTouchedKey = highestTouchedKey === coverAlert ? readOnlySummary : highestTouchedKey;
    return NavigationTabMenuControl({
      ...props,
      items: items,
      topLevelActiveKey: 'cover',
      highestTouchedKey: updatedHighestTouchedKey,
      topLevelHigestTouchedKey: isJourneyComplete ? 'claim' : 'cover',
      topLevelItems: [
        { name: 'Check your cover', key: 'cover' },
        {
          name: 'Log an incident',
          key: 'incident',
          onClick: submitClaimAction
        },
        { name: 'Submit a claim', key: 'claim', onClick: submitClaimAction }
      ]
    });
  };

  return NavigationTabControl;
};
